import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFeatureFilm$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFeatureFilm extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '8d6d57a9b0f5488780b8c2a3b9d0101ed64b31f8', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '384b1fa372e556650fb5767167eb041a5626e5a7', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '24030864b95c92b1caff0e5dc367d0feabc4427a', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.09 5.07c.11.108.27.15.42.11l2.29-.56a.5.5 0 0 0 .35-.6l-.42-1.95a.48.48 0 0 0-.57-.37l-3.63.88a.52.52 0 0 0-.21.87zM2.61 8.54l3.53-.86a.51.51 0 0 0 .2-.87L4.53 5.2a.42.42 0 0 0-.41-.11L2 5.62a.5.5 0 0 0-.36.6l.43 2a.46.46 0 0 0 .54.32M9.7 6.82a.65.65 0 0 1-.58-.15L7.38 5.12a.51.51 0 0 1 .2-.87L11 3.44a.67.67 0 0 1 .59.14l1.7 1.56a.51.51 0 0 1-.21.86zm.15 2.36-2 2a.5.5 0 0 0 .36.85h3.49a.47.47 0 0 0 .35-.15l2-2a.5.5 0 0 0 .16-.37.5.5 0 0 0-.5-.5h-3.44a.56.56 0 0 0-.42.17M17.73 9h1.81a.49.49 0 0 1 .46.48v10a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h3.81a.5.5 0 0 1 .34.87l-2 2a.5.5 0 0 1-.36.15H3.5v6.53h15v-6.5h-2.84a.5.5 0 0 1-.5-.5.48.48 0 0 1 .14-.35l2-2a.6.6 0 0 1 .43-.18", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-feature-film", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-feature-film"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-feature-film":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFeatureFilm$1);
            }
            break;
    } });
}

const CosmosIconFeatureFilm = CosmosIconFeatureFilm$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFeatureFilm, defineCustomElement };
